export default __webpack_public_path__ + "e06313f727cfcd3c5818e3bf2893bd1e.jpg";